import { Component, Input } from '@angular/core';
import { Award } from '@df/interfaces';

@Component({
    selector: 'app-named-card-award',
    templateUrl: './named_card_award.component.html',
    styleUrls: ['./named_card_award.component.scss']
})
export class NamedCardAwardComponent {
    @Input() award: Award;

    constructor() {}
}
